import { Injectable } from "@angular/core";

import { CustomFormControl } from "digital-core";

@Injectable({
  providedIn: "root"
})
export class NotEmptyValidator {
  constructor() {}

  isNotEmpty(component: CustomFormControl) {
    let str: string = component.value;
    if (!str) {
      return null;
    }
    if (str.trim().length > 0) {
      return null;
    } else {
      return { validateInput: { valid: false } };
    }
  }
}
